var _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.64 3.832s-4.139 8.214-6.699 8.346a5.53 5.53 0 01-.652-.01.742.742 0 00-.656-.408.74.74 0 00-.479.186c-.956-.353-1.394-.961-2.752-.877-1.982.123-4.172 4.814-4.172 4.814h15.41z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 3.488,
    x: 9.883,
    y: 6.67,
    rx: 0.75,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 3.488,
    x: 9.883,
    y: 1.73,
    rx: 0.75,
    ry: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.133 1.743a.748.748 0 00-.75.75v14.761c0 .416.334.75.75.75l.004-.002.006.002h7.74v1.504c0 .416.334.75.75.75.415 0 .75-.334.75-.75v-1.504h8.482a.75.75 0 100-1.502H2.883V2.492a.748.748 0 00-.75-.75z"
  })));
}
export default SvgInsights;